export const ACTION_TYPE = {
    SAVE_USER: "SAVE_USER",
    SAVE_DATA_PRINT: "SAVE_DATA_PRINT",
    COUNT_ATTACH_FILE: "COUNT_ATTACH_FILE"
};
